// Temporäre Konfiguration für Preisanzeige
// Um echte Preise wieder anzuzeigen, setze SHOW_TEMPORARY_PRICE auf false

export const PRICE_CONFIG = {
  SHOW_TEMPORARY_PRICE: false, // Auf false setzen um echte Preise anzuzeigen
  TEMPORARY_PRICE_TEXT: "Preis Demnächst"
};

// Zentrale Funktion für Preisformatierung
export const formatPrice = (price: number): string => {
  if (PRICE_CONFIG.SHOW_TEMPORARY_PRICE) {
    return PRICE_CONFIG.TEMPORARY_PRICE_TEXT;
  }
  return `${price.toLocaleString('de-CH')} CHF`;
};
